import React from 'react'
import PropTypes from 'prop-types'
import { GoogleLogin } from '@react-oauth/google'

import { sendError } from '@/utils/rollbar'

export default function GoogleLoginButton({ onSuccess, width = null }) {
  return (
    <GoogleLogin
      onError={errorResponse => sendError(errorResponse, 'Error signing in with Google')}
      onSuccess={onSuccess}
      width={width || 298}
    />
  )
}

GoogleLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  width: PropTypes.number,
}
